import React, { useEffect, useState } from 'react'
import shareIcon from '../../../../_metronic/assets/images/svg/data-room/share-icon.svg'
import folderIcon from '../../../../_metronic/assets/images/svg/data-room/blue-folder-icon.svg'
import moreOptionSmallIcon from '../../../../_metronic/assets/images/svg/data-room/more-options-small-icon.svg'
import OutsideClickHandler from 'react-outside-click-handler'
import { DataRoomFilesDropdown } from './DataRoomFilesDropdown'
import { Link } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { ContentTypes } from '../core/_constants'
import { toAbsoluteUrl } from '../../../../_metronic/helpers/index'
import { useDateFormat } from '../../../hooks/useDateFormat'
import { DateTime } from 'luxon'
import '../styles/DataRooms.scss'
import { useMoveToFolderData } from '../core/FileToFolderAuth'
import brandingConfig from '../../../../config/brandingConfig'
interface DataRoomFilesTableRowProps {
  data: {
    img: string
    name: string
    updatedAt: string
    visitCount: number
    contentId: string
    companyId: number
    parentId: string
    type: string
    file: any
  }
  getAllFilesContent: () => void
  getBreadcrumb: (value: string) => void
  setContentId: (value: string) => void
  dataRoomUploadsFolderContentId?: any
  getCompanyFolderChildren: (value: any) => void
  companyFolderContentId: any
  activeContentId?: any
}
const DataRoomFilesTableRow: React.FC<DataRoomFilesTableRowProps> = ({
  data,
  getAllFilesContent,
  getBreadcrumb,
  setContentId,
  dataRoomUploadsFolderContentId,
  getCompanyFolderChildren,
  companyFolderContentId,
  activeContentId,
}) => {
  const { formatMessage } = useIntl()
  const { getDateValue } = useDateFormat()
  const [menuOpen, setMenuOpen] = useState(false)
  const [oldNameForRename, setOldNameForRename] = useState<string>('')
  const [contentIdForRename, setContentIdForRename] = useState<string>('')
  const { setShareDrawer } = useMoveToFolderData()

  const handleShare = (contentId: string) => {
    setContentId(contentId)
  }

  const [showDeleteModal, setDeleteShowModal] = useState(false)
  useEffect(() => {
    if (data?.contentId === contentIdForRename) {
      let names = data?.name
      setOldNameForRename(names)
    }
  }, [contentIdForRename]) // eslint-disable-line

  console.log(data, ' data')
  return (
    <>
      {data.parentId === dataRoomUploadsFolderContentId && data.type === ContentTypes.FILE && (
        <tr>
          <td className='room-file-name '>
            <Link
              to={`/data-rooms/file-view/main-file-view/main-file-activity-view/${data.contentId}`}
              className=''
            >
              {data && data?.file?.name.split('.').pop() === 'pdf' && (
                <img
                  height={30}
                  width={30}
                  alt='pdf'
                  className='pe-2 ms-n1'
                  src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                />
              )}
              {data &&
                (data?.file?.name.split('.').pop() === 'docx' ||
                  data?.file?.name.split('.').pop() === 'doc') && (
                  <img
                    height={30}
                    width={30}
                    alt='docx'
                    className='pe-2 ms-n1'
                    src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                  />
                )}
              {data &&
                (data?.file?.name.split('.').pop() === 'pptx' ||
                  data?.file?.name.split('.').pop() === 'ppt') && (
                  <img
                    height={30}
                    width={30}
                    alt='pptx'
                    className='pe-2 ms-n1'
                    src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                  />
                )}
              {data &&
                (data?.file?.name.split('.').pop() === 'jpg' ||
                  data?.file?.name.split('.').pop() === 'png' ||
                  data?.file?.name.split('.').pop() === 'jpeg') && (
                  <img
                    height={30}
                    width={30}
                    alt='blank'
                    className='pe-2'
                    src={toAbsoluteUrl('/media/svg/files/blank-image-single.svg')}
                  />
                )}
              {data && data?.file?.name.split('.').pop() === 'xlsx' && (
                <img
                  height={30}
                  width={30}
                  alt='blank'
                  className='pe-2'
                  src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                />
              )}
              {data &&
                !(
                  data?.file?.name.split('.').pop() === 'pdf' ||
                  data?.file?.name.split('.').pop() === 'docx' ||
                  data?.file?.name.split('.').pop() === 'doc' ||
                  data?.file?.name.split('.').pop() === 'pptx' ||
                  data?.file?.name.split('.').pop() === 'ppt' ||
                  data?.file?.name.split('.').pop() === 'jpg' ||
                  data?.file?.name.split('.').pop() === 'png' ||
                  data?.file?.name.split('.').pop() === 'jpeg' ||
                  data?.file?.name.split('.').pop() === 'xlsx'
                ) && (
                  <img
                    height={27}
                    width={27}
                    alt='blank'
                    className='pe-2'
                    src={toAbsoluteUrl('/media/svg/files/blank-image-single.svg')}
                  />
                )}
              {data.name && (
                <span className='text-dark'>
                  {data.name.includes('/') ? data.name.split('/').pop() : data.name}
                  {data?.file?.name.split('.').pop()}
                </span>
              )}
            </Link>
          </td>
          <td className='last-updated text-dark'>
            {getDateValue(data?.updatedAt?.toString())
              ? getDateValue(data?.updatedAt?.toString())
              : DateTime.fromISO(data?.updatedAt).toFormat(brandingConfig.defaultDateFormat)}
          </td>
          <td className='recent-visits text-dark'>{data.visitCount}</td>
          <td className='Action'>
            <div className='d-flex align-items-center justify-content-end'>
              {/* {data.type !== ContentTypes.FOLDER && ( */}
              <button
                className='btn btn-sm btn-bg-light files-share-button font-size-12 font-weight-500  height-32 d-flex align-items-center justify-content-center '
                onClick={() => {
                  handleShare(data.contentId)
                  setShareDrawer(true)
                }}
              >
                <img src={shareIcon} alt=''></img>
                <span className='d-md-block d-none'>{formatMessage({ id: 'Share' })}</span>
              </button>
              {/* )} */}
              {/* {data.type === ContentTypes.FILE &&  */}
              <div className=' card-option-wrapper'>
                <OutsideClickHandler onOutsideClick={() => setMenuOpen(false)}>
                  <button
                    type='button'
                    className='btn btn-sm btn-bg-light card-option btn-icon btn-color-primary btn-active-light-primary'
                    onClick={() => setMenuOpen(!menuOpen)}
                  >
                    <img src={moreOptionSmallIcon} alt=''></img>
                  </button>
                  <DataRoomFilesDropdown
                    getAllFilesContent={getAllFilesContent}
                    isOpen={menuOpen}
                    contentId={data.contentId}
                    setDeleteShowModal={setDeleteShowModal}
                    showDeleteModal={showDeleteModal}
                    getBreadcrumb={getBreadcrumb}
                    type={data.type}
                    name={oldNameForRename}
                    setIsOpen={setMenuOpen}
                    setContentIdForRename={setContentIdForRename}
                    fileNameProp={data?.file?.name}
                    getCompanyFolderChildren={getCompanyFolderChildren}
                    companyFolderContentId={companyFolderContentId}
                    activeContentId={activeContentId}
                  />
                </OutsideClickHandler>
              </div>
            </div>
          </td>
        </tr>
      )}
      {data.parentId !== dataRoomUploadsFolderContentId && (
        <tr>
          {data.type === ContentTypes.FILE && (
            <td className='room-file-name '>
              <Link
                to={`/data-rooms/file-view/main-file-view/main-file-activity-view/${data.contentId}`}
                className=''
              >
                {data && data?.file?.name.split('.').pop() === 'pdf' && (
                  <img
                    height={30}
                    width={30}
                    alt='pdf'
                    className='pe-2'
                    src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                  />
                )}
                {data &&
                  (data?.file?.name.split('.').pop() === 'docx' ||
                    data?.file?.name.split('.').pop() === 'doc') && (
                    <img
                      height={30}
                      width={30}
                      alt='docx'
                      className='pe-2'
                      src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                    />
                  )}
                {data &&
                  (data?.file?.name.split('.').pop() === 'pptx' ||
                    data?.file?.name.split('.').pop() === 'ppt') && (
                    <img
                      height={30}
                      width={30}
                      alt='pptx'
                      className='pe-2'
                      src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                    />
                  )}
                {data &&
                  (data?.file?.name.split('.').pop() === 'jpg' ||
                    data?.file?.name.split('.').pop() === 'png' ||
                    data?.file?.name.split('.').pop() === 'jpeg') && (
                    <img
                      height={30}
                      width={30}
                      alt='blank'
                      className='pe-2'
                      src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                    />
                  )}
                {data && data?.file?.name.split('.').pop() === 'xlsx' && (
                  <img
                    height={30}
                    width={30}
                    alt='blank'
                    className='pe-2'
                    src={toAbsoluteUrl(`/media/icons/file_extensions/${data?.file?.name.split('.').pop()}.svg`)}
                  />
                )}
                {data &&
                  !(
                    data?.file?.name.split('.').pop() === 'pdf' ||
                    data?.file?.name.split('.').pop() === 'docx' ||
                    data?.file?.name.split('.').pop() === 'doc' ||
                    data?.file?.name.split('.').pop() === 'pptx' ||
                    data?.file?.name.split('.').pop() === 'ppt' ||
                    data?.file?.name.split('.').pop() === 'jpg' ||
                    data?.file?.name.split('.').pop() === 'png' ||
                    data?.file?.name.split('.').pop() === 'jpeg' ||
                    data?.file?.name.split('.').pop() === 'xlsx'
                  ) && (
                    <img
                      height={20}
                      width={20}
                      alt='blank'
                      className='pe-2'
                      src={toAbsoluteUrl('/media/svg/files/blank-image-single.svg')}
                    />
                  )}
                {data.name && (
                  <span className='text-dark'>
                    {data.name.includes('/') ? data.name.split('/').pop() : data.name}.
                    {data?.file?.name.split('.').pop()}
                  </span>
                )}
              </Link>
            </td>
          )}
          {data.type === ContentTypes.FOLDER && (
            <td
              className='room-file-name cursor-pointer'
              onClick={() => {
                if (activeContentId === companyFolderContentId) {
                  getCompanyFolderChildren(data.contentId)
                } else {
                  getBreadcrumb(data.contentId)
                }
              }}
            >
              <img src={folderIcon} alt='folder' className='pe-2'></img>
              {data?.name && <span className='text-dark'>{data?.name}</span>}
            </td>
          )}
          <td className='last-updated text-dark'>
            {getDateValue(data?.updatedAt?.toString())
              ? getDateValue(data?.updatedAt?.toString())
              : DateTime.fromISO(data?.updatedAt).toFormat('dd MMM, yyyy')}
          </td>
          {data.type === ContentTypes.FILE ? (
            <td className='recent-visits text-dark'>{data.visitCount}</td>
          ) : (
            <td className='recent-visits text-dark'>-</td>
          )}

          <td className='Action'>
            <div className='d-flex align-items-center justify-content-end'>
              {data.type !== ContentTypes.FOLDER && (
                <button
                  className='btn btn-sm btn-bg-light files-share-button font-size-12 font-weight-500  height-32 d-flex align-items-center justify-content-center '
                  onClick={() => {
                    handleShare(data.contentId)
                    setShareDrawer(true)
                  }}
                >
                  <img src={shareIcon} alt=''></img>
                  <span className='d-md-block d-none'>{formatMessage({ id: 'Share' })}</span>
                </button>
              )}

              <div className=' card-option-wrapper'>
                <OutsideClickHandler onOutsideClick={() => setMenuOpen(false)}>
                  <button
                    type='button'
                    className='btn btn-sm btn-bg-light card-option btn-icon btn-color-primary btn-active-light-primary'
                    onClick={() => setMenuOpen(!menuOpen)}
                  >
                    <img src={moreOptionSmallIcon} alt=''></img>
                  </button>
                  <DataRoomFilesDropdown
                    getAllFilesContent={getAllFilesContent}
                    isOpen={menuOpen}
                    contentId={data.contentId}
                    setDeleteShowModal={setDeleteShowModal}
                    showDeleteModal={showDeleteModal}
                    getBreadcrumb={getBreadcrumb}
                    type={data.type}
                    name={oldNameForRename}
                    setIsOpen={setMenuOpen}
                    setContentIdForRename={setContentIdForRename}
                    fileNameProp={data?.file?.name.split('/').pop()}
                    getCompanyFolderChildren={getCompanyFolderChildren}
                    companyFolderContentId={companyFolderContentId}
                    activeContentId={activeContentId}
                  />
                </OutsideClickHandler>
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  )
}

export default DataRoomFilesTableRow
